import { render } from "./CustomerAddressCreateComponent.vue?vue&type=template&id=639badab"
import script from "./CustomerAddressCreateComponent.vue?vue&type=script&lang=js"
export * from "./CustomerAddressCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/customers/address/CustomerAddressCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "639badab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('639badab', __exports__)) {
    api.reload('639badab', __exports__)
  }
  
  module.hot.accept("./CustomerAddressCreateComponent.vue?vue&type=template&id=639badab", () => {
    api.rerender('639badab', render)
  })

}


export default __exports__